// Reference-pitch-aware tuning maths (12-TET anchored at a configurable A4).
// Pure functions only — unit-tested by node (see /app/memory for results).
// Every conversion honours the choir's concert pitch; nothing hard-codes 440 Hz.
export const DEFAULT_A4 = 440;
export const IN_TUNE_CENTS = 15;
export const HOLD_MS = 500;

const NOTE_NAMES = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"];

export function midiToFreq(midi, refA4 = DEFAULT_A4) {
  return refA4 * Math.pow(2, (midi - 69) / 12);
}

export function freqToMidiFloat(freq, refA4 = DEFAULT_A4) {
  return 69 + 12 * Math.log2(freq / refA4);
}

export function midiToName(midi) {
  const m = Math.round(midi);
  return NOTE_NAMES[((m % 12) + 12) % 12] + (Math.floor(m / 12) - 1);
}

// freq -> nearest note under the choir's concert pitch, with cents deviation
// from that note (still measured against the configured reference).
export function freqToNote(freq, refA4 = DEFAULT_A4) {
  if (!freq || freq <= 0) return null;
  const midiFloat = freqToMidiFloat(freq, refA4);
  const midi = Math.round(midiFloat);
  return { midi, name: midiToName(midi), cents: Math.round((midiFloat - midi) * 100), midiFloat };
}

// Cents between a detected frequency and a target note, honouring concert pitch.
export function centsFromTarget(freq, targetMidi, refA4 = DEFAULT_A4) {
  return Math.round(1200 * Math.log2(freq / midiToFreq(targetMidi, refA4)));
}

// Target choices for children and young voices (unchanged/treble range A3–D5).
export const TARGET_MIDIS = [57, 59, 60, 62, 64, 65, 67, 69, 71, 72, 74];
